import { URLS } from "config/urls";
import theme from "theme";
import { colors } from "theme/palette";
import { format, FORMATS, parseJSON } from "utils/datetime";
import { reverse } from "utils/urls";

import Card, { CardActionArea } from "components/Card";
import Link from "components/Link";
import Stack from "components/Stack";
import Text from "components/Text";

import { EApplicationCreatedByNonPayingCustomerStatus } from "entities/Application/constants";
import { IApplicationCreatedByNonPayingCustomer } from "entities/Application/sdk";

export interface IApplicationBox {
  application: IApplicationCreatedByNonPayingCustomer;
}

const ApplicationBox = ({ application }: IApplicationBox) => (
  <Link
    to={reverse(URLS.APPLICATION_EDIT, {
      applicationId: application.id,
    })}
  >
    <Card
      sx={{
        flexDirection: "column",
        flexGrow: 1,
        borderRadius: 3,
        height: "100%",
        boxShadow: `0 4px 8px 0 ${colors.gray20}`,
        "&:hover": {
          boxShadow: `0 4px 8px 0 ${colors.gray60}`,
        },
      }}
    >
      <CardActionArea
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          padding: theme.spacing(1, 2),
          gap: 0.8,
        }}
      >
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          gap={0.8}
        >
          <Text
            fontSize={11}
            fontWeight={500}
            sx={{
              backgroundColor:
                application.status ===
                EApplicationCreatedByNonPayingCustomerStatus.DRAFT
                  ? colors.blue20
                  : colors.gray80,
              padding: theme.spacing(0.4, 0.8),
              color:
                application.status ===
                EApplicationCreatedByNonPayingCustomerStatus.DRAFT
                  ? colors.blue100
                  : colors.white,
            }}
          >
            {application.status.toUpperCase()}
          </Text>
          <Text
            fontSize={11}
            fontWeight={500}
            sx={{
              backgroundColor: colors.gray20,
              color: colors.gray80,
            }}
            padding={theme.spacing(0.4, 0.8)}
          >
            {application.code}
          </Text>
        </Stack>
        <Stack>
          <Text fontSize={16} fontWeight={800}>
            {application.owner_given_name}
          </Text>
          <Text fontSize={15} fontWeight={400}>
            {application.company.name}
          </Text>
        </Stack>
        <Stack
          sx={{
            backgroundColor: colors.blue20,
            borderRadius: "4px",
            width: "fit-content",
          }}
          padding={theme.spacing(0.4, 0.8)}
        >
          <Text fontWeight={600} fontSize={13}>
            {application.name}
          </Text>
        </Stack>
        {application.status ===
          EApplicationCreatedByNonPayingCustomerStatus.DRAFT && (
          <Text
            fontWeight={400}
            fontSize={13}
            color={colors.gray80}
            marginTop="auto"
          >
            Last edited at{" "}
            {format(
              parseJSON(application.updated_at),
              FORMATS.FRONTEND.DATETIME
            )}
          </Text>
        )}
        {application.status ===
          EApplicationCreatedByNonPayingCustomerStatus.SUBMITTED && (
          <Text
            fontWeight={400}
            fontSize={13}
            color={colors.gray80}
            marginTop="auto"
          >
            Sumitted at{" "}
            {format(
              parseJSON(application.submitted_at),
              FORMATS.FRONTEND.DATETIME
            )}
          </Text>
        )}
      </CardActionArea>
    </Card>
  </Link>
);

export default ApplicationBox;
